<template>
  <div v-show="show" class="picker-position" :class="{ 'is-down': !isUp, 'is-up': isUp }">
    <Picker
      :id="getEmojiPickerId()"
      :emoji-size="21"
      :perLine="9"
      :native="true"
      :showPreview="false"
      :data="ei"
      @select="addVariableToText"
      class="emoji-picker"
    ></Picker>

    <div :class="{ 'arrow-down': isUp, 'arrow-up': !isUp }">
      <div class="inner-arrow"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src';
import data from '../../../../../assets/emojis.json';
import { nanoid } from 'nanoid';
import { nextTick, onBeforeMount, ref, watch } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'insertEmoji', emoji: any): void;
}>();

const pickerId = ref('');
const isUp = ref(false);

const ei = new EmojiIndex(data, { recentLength: 8, exclude: ['flags', 'symbols'] });

onBeforeMount(() => (pickerId.value = nanoid(7)));

watch(
  () => props.show,
  () => nextTick(() => (isUp.value = isEmojiPickerUp())),
  { immediate: true },
);

function addVariableToText(variable: any) {
  emit('insertEmoji', variable);
}

function getEmojiPickerId() {
  return `emoji-picker-${pickerId.value}`;
}

function isEmojiPickerUp() {
  const menu = document.querySelector(`#${getEmojiPickerId()}`);
  if (menu) {
    const position = menu.getBoundingClientRect();
    const padding = 10;
    if (position.bottom > window.innerHeight - padding) {
      return true;
    }
  }
  return false;
}
</script>

<style scoped lang="scss">
.picker-position {
  position: absolute;
}

.is-down {
  bottom: -5px;
}

.is-up {
  bottom: 333px;
}

.emoji-picker {
  position: absolute;
  z-index: 50;
  height: 300px;
  width: 400px;
  right: -290px;
}

.arrow-up {
  left: 3px;
  top: -8px;
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #dadada;
  bottom: -1px;
  z-index: 9999;
  .inner-arrow {
    position: relative;
    width: 0;
    height: 0;
    top: 1.5px;
    right: 10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgb(255, 255, 255);
  }
}
.arrow-down {
  left: 3px;
  top: 300px;
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #dadada;
  z-index: 9999;

  .inner-arrow {
    position: relative;
    width: 0;
    height: 0;
    bottom: 11.5px;
    right: 10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid rgb(255, 255, 255);
  }
}
</style>
